import {
  BrandConfigCustomizationsContact,
  BrandConfigCustomizationsImage,
  BrandConfigCustomizationsLink,
} from "../types/graphql/generated";
import { formatCityStateZipByCountry, formatStreetByCountry } from "./address";
import { FooterBranding } from "../components/Footer/Branding";
import { FooterLink } from "../components/Footer/NavigationLinks";

export const getSortedFooterLinks = (
  links: BrandConfigCustomizationsLink[],
  urlBase?: string
): FooterLink[] => {
  return links
    .filter((link) => link.location === "footer")
    .sort((a, b) => a.position - b.position)
    .map((link) => {
      const isInternal = urlBase ? link.url.includes(urlBase) : false;
      return {
        name: link.title,
        url: link.url,
        isOpenNewTab: link.newTab,
        isInternal,
      };
    });
};

export const getFooterBranding = (
  contacts: BrandConfigCustomizationsContact[],
  images: BrandConfigCustomizationsImage[]
): FooterBranding => {
  const logo = images.find(
    (img: BrandConfigCustomizationsImage) => img.name === "logoLargeLightUrl"
  );

  const contact = contacts.find(
    (contact: BrandConfigCustomizationsContact) => contact.type === "footer"
  );

  const { city, countryCode, line1, line2, phoneNumber, state, zip } =
    contact || {};

  return {
    logoImgLink: logo?.src || "",
    phoneNumber: phoneNumber || "",
    addressLine1: formatStreetByCountry({
      line1,
      line2,
      countryFormat: countryCode,
    }),
    addressLine2: formatCityStateZipByCountry({
      city,
      state,
      zip,
      countryFormat: countryCode,
    }),
  };
};
